import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { NotificationsState, ToastKind } from './types';

const initialState: NotificationsState = {
  toasts: [],
};

let nextToastId = 1;

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    showToast: (
      state,
      action: PayloadAction<{
        text: string;
        state?: ToastKind;
        icon?: 'check' | 'default' | 'info' | 'warning' | 'error' | 'network-lost';
        loading?: boolean;
        buttonSecondaryText?: string;
        buttonPrimaryText?: string;
        buttonPrimaryHref?: string;
        showCloseButton?: boolean;
        position?: 'top-center' | 'top-right';
        autoDismiss?: boolean;
        toastType?: string;
      }>,
    ) => {
      // Replace existing toasts instead of adding to the list
      state.toasts = [
        {
          id: nextToastId++,
          text: action.payload.text,
          state: action.payload.state || 'default',
          icon: action.payload.icon,
          loading: action.payload.loading,
          buttonSecondaryText: action.payload.buttonSecondaryText,
          buttonPrimaryText: action.payload.buttonPrimaryText,
          buttonPrimaryHref: action.payload.buttonPrimaryHref,
          showCloseButton: action.payload.showCloseButton !== false, // Default to true unless explicitly false
          position: action.payload.position,
          autoDismiss: action.payload.autoDismiss !== false, // Default to true unless explicitly false
          toastType: action.payload.toastType,
        },
      ];
    },
    dismissToast: (state, action: PayloadAction<number>) => {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    clearToasts: (state) => {
      state.toasts = [];
    },
  },
});

export const { showToast, dismissToast, clearToasts } = notificationsSlice.actions;
export default notificationsSlice.reducer;
